export default "__VITE_ASSET__BKsWwn2a__"